import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { filter, map, switchMap, take } from "rxjs/operators";
import { AuthService } from "../auth/auth.service";

@Injectable()
export class AzureTokenInterceptor implements HttpInterceptor {
  private readonly authService: AuthService = inject(AuthService);
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.token.pipe(
      filter((token: string | undefined): token is string => !!token),
      take(1),
      map((token: string) => ({
        token,
        appendToken: this.authService.resourceNeedsToken(req.url)
      })),
      switchMap(({ token, appendToken }) => {
        const clonedReq =
          token && appendToken
            ? req.clone({
                setHeaders: {
                  Authorization: `Bearer ${token}`
                }
              })
            : req;

        return next.handle(clonedReq);
      })
    );
  }

}
